// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__VZrkp","content":"style_content__MqRGG","text":"style_text__0UYvJ","frame":"style_frame__1fuQy"};